import { create } from 'zustand'
import { TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS } from '../constants'

export const useHutritClubUploadTalentStore = create((set) => ({
  currentStep: 0,
  setCurrentStep: (value) => set(() => ({ currentStep: value })),
  currentSubStep: 0,
  setCurrentSubStep: (value) => set(() => ({ currentSubStep: value })),
  isEditVideo: false,
  setIsEditVideo: (value) => set(() => ({ isEditVideo: value })),
  isHutritChallenge: false,
  setIsHutritChallenge: (value) => set(() => ({ isHutritChallenge: value })),
  selectedChallenge: '',
  setSelectedChallenge: (value) => set(() => ({ selectedChallenge: value })),
}))

export const useTabBarUploadVideoTalentStore = create((set) => ({
  tabBarValue: TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.instructions,
  setTabBarValue: (value) => set(() => ({ tabBarValue: value })),
}))
